<script setup lang="ts">
import { computed } from "vue";
import Icon from "@/components/Core/Icon.vue";
import { FEEDBACK_COPY } from "@/copy/feedback";

const props = defineProps({
  step: { type: Number, required: true },
  total: { type: Number, required: true },
});
const emit = defineEmits({ back: () => true, close: () => true });

const progress = computed(() => `${((props.step + 1) / props.total) * 100}%`);
</script>

<template>
  <div class="flex h-12 items-center gap-2 px-2">
    <button
      type="button"
      :aria-label="FEEDBACK_COPY.back"
      class="rounded-md p-2 text-gray-600 hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-700"
      :class="{ invisible: step === 0 }"
      @click="emit('back')"
    >
      <Icon name="arrow-left" class="size-4" aria-hidden="true" />
    </button>
    <span
      class="text-xs font-semibold tracking-wide whitespace-nowrap text-violet-700 uppercase"
    >
      {{ FEEDBACK_COPY.progress(step + 1, total) }}
    </span>
    <div
      aria-hidden="true"
      class="h-1 flex-1 overflow-hidden rounded-full bg-gray-100"
    >
      <div
        class="h-full w-(--progress) rounded-full bg-purple-700 motion-safe:transition-[width] motion-safe:duration-300 motion-safe:ease-[cubic-bezier(0.32,0.72,0,1)] starting:w-0"
        :style="{ '--progress': progress }"
      />
    </div>
    <button
      type="button"
      :aria-label="FEEDBACK_COPY.close"
      class="rounded-md p-2 text-gray-600 hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-700"
      @click="emit('close')"
    >
      <Icon name="times" class="size-4" aria-hidden="true" />
    </button>
  </div>
</template>
